// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-material/dist/vue-material.min.css
// module id = 275
// module chunks = 0